import QualifiedFamiliesPage from '../../pages/QualifiedFamiliesPage';
import FamilyList from '../../pages/QualifiedFamiliesPage/FamilyList';

export default {
    path: '/rodziny-przypisane',
    component: QualifiedFamiliesPage,
    meta: { requiresAuth: true },
    children: [
        {
            name: 'families-list',
            path: '',
            component: FamilyList
        }
    ]
};
